import create from './create'
import edit from './edit'
import list from './list'
export default {
    create: create,
    list: list,
    edit: edit, 
    name: "configs",
    key: "p_configs",
}